import { Suspense, lazy } from 'react';
import { useHistory } from 'react-router';

import { PATHS } from '.';
import { ReactComponent as ClueyPlusLogo } from '../../../../assets/icons/cluey-plus-logo.svg';
import env from '../../../../env';
import { useReviewDetailsStore } from './SignUpReviewDetailsPage';
import { StudentEntryForm } from './SignUpStudentDetails';

const VIDEO_URL = env.REACT_APP_SIGNUP_SUCCESS_VIDEO_URL ?? '';
const ReactPlayer = lazy(() => import('react-player'));

const Students = ({ students }: { students: StudentEntryForm[] }) => {
  // case 1: students.length === 1, i.e. Kerri
  if (students?.length === 1) {
    return <span className="font-bold">{students[0].firstName}.</span>;
  }
  // case 2: students.length === 2
  if (students?.length === 2) {
    return (
      <>
        <span className="font-bold">{students[0].firstName}</span>
        <span> and </span>
        <span className="font-bold">{students[1].firstName}.</span>
      </>
    );
  }
  // case 3: students.length > 2
  // must show all students name, separated by commas
  // last student should include "and", i.e. "James, Charley, and Olivia"
  const lastStudent = students[students.length - 1];
  const otherStudents = students.slice(0, -1);
  return (
    <span className="font-bold">
      {otherStudents.map((student) => student.firstName).join(', ')} and {lastStudent.firstName}.
    </span>
  );
};

const SignUpSuccessPage = () => {
  const history = useHistory();
  const { signUpUser, students } = useReviewDetailsStore();

  if (!signUpUser || !students) {
    history.replace(PATHS.STUDENT_DETAILS_PATH);
  }

  return (
    <div className="ml-auto mr-auto box-content flex h-full flex-col items-center px-5">
      <div className="max-w-[420px]">
        <div className="mt-20">
          <div className="m-auto flex items-center justify-center">
            <ClueyPlusLogo className="h-[41px] w-[140px]" />
          </div>
        </div>
        <h2 className="my-5 text-center font-display text-4xl font-bold">Cluey+ free trial activated</h2>
        <div className="mt-6 text-center">
          <span className="mr-1">Your free trial starts now for</span>
          <Students students={students} />
        </div>
        <div className="mt-4 text-center">You'll receive a confirmation email with a link to Cluey+ soon.</div>
      </div>
      <div className="container pb-5 md:pb-10">
        {VIDEO_URL && (
          <div className="mt-6 aspect-video w-full overflow-hidden rounded-lg">
            <Suspense fallback={null}>
              <ReactPlayer src={VIDEO_URL} controls width="100%" height="100%" />
            </Suspense>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignUpSuccessPage;
